
export default {
  name: 'icon-twitter',
};
